import { render, staticRenderFns } from "./MedicaidCertificationRow.vue?vue&type=template&id=13518a90&scoped=true"
import script from "./MedicaidCertificationRow.vue?vue&type=script&lang=js"
export * from "./MedicaidCertificationRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13518a90",
  null
  
)

export default component.exports